/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import {
  ActionRequest,
  Asset,
  Ducks,
  XError,
  PageToPageNavigationLaunchButtons,
  PageToPageNavigationPageNames,
} from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { all, call, takeEvery } from 'redux-saga/effects';
import { getMainPageName, getSubPageName } from './navigationUtils';

export enum ActionType {
  ROUTE_CHANGE = 'analytics/navigationWatcher/ROUTE_CHANGE',
}

interface Meta {
  path: string;
  click: boolean;
  asset?: Asset;
  error?: XError;
}

export type RouteChange = ActionRequest<ActionType.ROUTE_CHANGE, Meta>;

const Actions = {
  routeChange: (path: string, click: boolean, asset?: Asset, error?: XError): RouteChange => ({
    type: ActionType.ROUTE_CHANGE,
    meta: { path, click, asset, error },
  }),
};

export const ActionCreators = {
  routeChange: Actions.routeChange,
};

function getPageName(path: string): PageToPageNavigationPageNames | undefined {
  const subPage = getSubPageName(path);
  if (subPage) {
    return subPage;
  }
  return getMainPageName(path);
}

function* watchRouteChange(action: RouteChange): SagaIterator {
  const { path, asset, error, click } = action.meta;
  const pageName = getPageName(path);

  if (pageName) {
    yield call(
      Ducks.PageToPageNavigationEvents.addPageToPageNavigationEvent,
      pageName,
      path,
      click ? PageToPageNavigationLaunchButtons.CLICK : PageToPageNavigationLaunchButtons.BROWSER_NAVIGATION,
      asset,
      error
    );
  } else {
    // unknown page, discard event
  }
}

export function* saga(): SagaIterator {
  yield all([takeEvery(ActionType.ROUTE_CHANGE, watchRouteChange)]);
}
